
import './App.css';
import Home from './components/Home';
import { ThemeProvider, createTheme } from '@mui/material/styles';

const theme = createTheme();

function App() {
  return (
    <div className="App">
        <ThemeProvider theme={theme}>
        <Home/>
        </ThemeProvider>
    </div>
  );
}

export default App;
 